module.exports = __webpack_public_path__ + "media/images/captive_portal/Like-762228e961a5105aa0fdbdadbfa007c2.svg";